import { useAppTheme } from "../theme/AppTheme";

/** Whether the app uses a dark theme (Teams dark/high contrast theme in Teams, OS preference in a browser). */
export const useDarkMode = (): boolean => useAppTheme().isDark;
